import * as React from 'react'
import styled from 'styled-components'
import Svg from './Svg'

function BaseComponent(props: any) {
  return (
    <Svg
      width={15}
      height={15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.182 8.818a.45.45 0 010-.636l3-3a.45.45 0 01.636 0l3 3a.45.45 0 01-.636.636L7.5 6.136 4.818 8.818a.45.45 0 01-.636 0z"
        fill="currentColor"
      />
    </Svg>
  )
}

const SvgCaretUp = styled(BaseComponent)`
  outline: none;
`
export default SvgCaretUp
